import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=728b6952&scoped=true"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"
import style0 from "./Unit.vue?vue&type=style&index=0&id=728b6952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b6952",
  null
  
)

export default component.exports